import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	discoverMoreAutomationMenuItemLabel: {
		id: 'software-releases-automation-menu.menu-contents.template-rules.discover-more-automation-menu-item-label',
		defaultMessage: 'Discover more automation',
		description: 'A label for the popup menu item for Discover automation deep-link',
	},
	templateRuleAddIssueToVersionOnVersionCreate: {
		id: 'software-releases-automation-menu.menu-contents.template-rules.template-rule-add-issue-to-version-on-version-create',
		defaultMessage:
			'When a version is created → then add all In Progress issues without a fix version',
		description: 'Title or short name for an automation rule described by the defaultMessage.',
	},
	templateRuleCreateLaunchDarklyFlagOnVersionCreate: {
		id: 'software-releases-automation-menu.menu-contents.template-rules.template-rule-create-launch-darkly-flag-on-version-create',
		defaultMessage: 'When a version is created → then create a LaunchDarkly flag',
		description: 'Title or short name for an automation rule described by the defaultMessage.',
	},
	templateRuleSendSlackMessageOnVersionRelease: {
		id: 'software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-release',
		defaultMessage: 'When a version is released → then send a Slack message',
		description: 'Title or short name for an automation rule described by the defaultMessage.',
	},
	templateRuleSendSlackMessageOnVersionUnRelease: {
		id: 'software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-un-release',
		defaultMessage: 'When a version is unreleased → then send a Slack message',
		description: 'Title or short name for an automation rule described by the defaultMessage.',
	},
});
